module.exports = __webpack_public_path__ + "static/media/polygonscan-logo.85ff4c48.svg";